export function constructFilter(filters, isPreview) {
    if (!filters && !isPreview) {
        return ''
    }

    const filtersArray = Object.entries(filters).map(([filter, value]) =>
        filter + '=' + encodeURIComponent(JSON.stringify(value))
    )

    if (isPreview) {
        filtersArray.push(`preview=${isPreview}`)
    }

    return `?${filtersArray.join('&')}`
}
